import { IListFetcher } from '../fetchers/IListFetcher';
import { Filter } from '../helpers/Filter';
import { ServerApiMapper } from '../helpers/ServerModelHelper';
import { FlowOutputStepRunListItemInfo } from '../models/FlowOutputStepRunInfo';
import { Module } from '../Module';
import { GetFieldValuesRequest } from '../ServerApi/requests/GetFieldValuesRequest';
import { GetFlowOutputStepRunsRequest } from '../ServerApi/requests/GetFlowOutputStepRunsRequest';
import { GetMostRecentFlowOutputStepRunRequest } from '../ServerApi/requests/GetMostRecentFlowOutputStepRunRequest';
import { IFieldValue } from '../ServerApi/types/IFieldValue';
import { FilterFieldNames, ILeafFilterClause } from '../ServerApi/types/IFilterClause';
import { IOrderClause } from '../ServerApi/types/IOrderClause';
import { ErrorNotifyingServer } from '../services/ErrorNotifyingServer';
import { FetcherFactory } from '../services/FetcherFactory';
import { ServerService } from '../services/ServerService';
import { FieldValuesQuery } from './FieldValuesQuery';
import { IListResource } from './Resource';
import { ResourceQuery } from './ResourceQuery';

export class FlowOutputStepRuns implements IListResource<FlowOutputStepRunListItemInfo> {

  public static $inject = [
    'ErrorNotifyingServer',
    'FetcherFactory'
  ];

  private server: ServerService;
  private listFetcher: IListFetcher<FlowOutputStepRunListItemInfo>;
  private allQuery: ResourceQuery<FlowOutputStepRunListItemInfo>;
  private fieldValuesFetcher: IListFetcher<IFieldValue>;

  constructor(
    ErrorNotifyingServer: ErrorNotifyingServer,
    FetcherFactory: FetcherFactory
  ) {
    this.server = ErrorNotifyingServer.getServerService();
    this.listFetcher = FetcherFactory.getServerResourceFetcher(GetFlowOutputStepRunsRequest, ServerApiMapper.flowOutputStepRuns);
    this.allQuery = new ResourceQuery(this.listFetcher);
    this.fieldValuesFetcher = FetcherFactory.getServerResourceFetcher(GetFieldValuesRequest, ServerApiMapper.fieldValues);
  }

  public all(): ResourceQuery<FlowOutputStepRunListItemInfo> {
    return this.allQuery;
  }

  public getForFlow(flowId: string, orderClause: IOrderClause[]): ResourceQuery<FlowOutputStepRunListItemInfo> {
    const filterClause: ILeafFilterClause[] = [Filter.stringFieldEq(FilterFieldNames.flowId, flowId)];
    return this.allQuery.withFiltersAndOrder(filterClause, orderClause);
  }

  public getMostRecentForFlow(flowId: string, completedRunsOnly: boolean): ng.IPromise<ReadonlyArray<FlowOutputStepRunListItemInfo>> {
    return this.server.sendRequest(new GetMostRecentFlowOutputStepRunRequest({ flowId, completedRunsOnly }))
      .then((result) => ServerApiMapper.flowOutputStepRuns(result));
  }

  public valuesForField(field: string): FieldValuesQuery {
    return new FieldValuesQuery(this.fieldValuesFetcher, field, 'flowOutputStepRun');
  }
}

Module.instance().service('FlowOutputStepRuns', FlowOutputStepRuns);
